<form [formGroup]="getFormGroup()">

  <div class="item rounded freight-payer-grid p-2">
    <div class="row">
      <div class="p-2">
        <div class="mb-2 mogo-header-2 text-start p-2 border-bottom">
          Attachments
        </div>
      </div>
    </div>
    <div>
      @if (getFormGroup().get('documents')) {
      <app-mogo-dropzone formControlName="documents" height="250px"></app-mogo-dropzone>
      }
    </div>
  </div>

</form>